import { Controller } from "@hotwired/stimulus"

// Keeps a typed-but-not-submitted company domain attached to the "Sign up with
// Google" button's form, so it survives the OAuth redirect and comes back in
// omniauth.params (read in Account::Oauth::OmniauthCallbacksController).
// OmniAuth only persists QUERY params from the authorize request (request.GET),
// so the domain goes into the form's action URL — a hidden body field would be
// dropped.
export default class extends Controller {
  static targets = ["source"]

  connect() {
    this.sync()
  }

  sync() {
    const button = document.getElementById("sign_in_with_google")
    const form = button && button.form
    if (!form) return

    const url = new URL(form.getAttribute("action"), window.location.origin)
    const domain = this.sourceTarget.value.trim()
    if (domain) {
      url.searchParams.set("company_domain", domain)
    } else {
      url.searchParams.delete("company_domain")
    }
    form.setAttribute("action", url.pathname + url.search)
  }
}
